const EditPassengerStyles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
  },
});

export default EditPassengerStyles;



// WEBPACK FOOTER //
// ./src/containers/passengers/common/editPassenger/EditPassengerStyles.js